/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface DocumentDownload
 */
export interface DocumentDownload {
    /**
     * 
     */
    url: string;
    /**
     * 
     */
    expires_at: Date;
}

/**
 * Check if a given object implements the DocumentDownload interface.
 */
export function instanceOfDocumentDownload(value: object): value is DocumentDownload {
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('expires_at' in value) || value['expires_at'] === undefined) return false;
    return true;
}

export function DocumentDownloadFromJSON(json: any): DocumentDownload {
    return DocumentDownloadFromJSONTyped(json, false);
}

export function DocumentDownloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentDownload {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
        'expires_at': (json['expires_at'] == null ? json['expires_at'] : parseDateTime(json['expires_at'])),
    };
}

export function DocumentDownloadToJSON(json: any): DocumentDownload {
    return DocumentDownloadToJSONTyped(json, false);
}

export function DocumentDownloadToJSONTyped(value?: DocumentDownload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
        'expires_at': value['expires_at'] == null ? value['expires_at'] : serializeDateTime(value['expires_at']),
    };
}

